module.exports = __webpack_public_path__ + "assets/img/Understand.85a5e0d2.svg";